import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { AuthLayout } from '../components/layout';
import { Alert, Button, Spinner } from '../components/ui';
import { api } from '../services/api';
import { CheckCircle, XCircle } from 'lucide-react';

export const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');

      if (!token) {
        setError('Invalid verification link');
        setLoading(false);
        return;
      }

      try {
        await api.auth.verifyEmail(token);
        setSuccess(true);
      } catch (err: any) {
        setError(err.response?.data?.error || 'Verification failed');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <AuthLayout title="Email Verification">
      <div className="text-center space-y-6">
        {loading && (
          <div className="flex flex-col items-center gap-4">
            <Spinner size="lg" />
            <p className="text-gray-600">Verifying your email...</p>
          </div>
        )}

        {!loading && success && (
          <>
            <div className="flex justify-center">
              <CheckCircle size={64} className="text-green-500" />
            </div>
            <Alert variant="success">
              Your email has been successfully verified!
            </Alert>
            <Button
              variant="primary"
              fullWidth
              onClick={() => navigate('/dashboard')}
            >
              Go to Dashboard
            </Button>
          </>
        )}

        {!loading && error && (
          <>
            <div className="flex justify-center">
              <XCircle size={64} className="text-red-500" />
            </div>
            <Alert variant="danger">
              {error}
            </Alert>
            <div className="space-y-2">
              <Link to="/login">
                <Button variant="primary" fullWidth>
                  Back to Login
                </Button>
              </Link>
            </div>
          </>
        )}
      </div>
    </AuthLayout>
  );
};
